import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import GridList from '@material-ui/core/GridList';
import GridListTile from '@material-ui/core/GridListTile';
import GridListTileBar from '@material-ui/core/GridListTileBar';
import IconButton from '@material-ui/core/IconButton';
import FavoriteOutlinedIcon from '@material-ui/icons/FavoriteOutlined';
import SmsOutlinedIcon from '@material-ui/icons/SmsOutlined';
import ShareOutlinedIcon from '@material-ui/icons/ShareOutlined';
import Imagemodal from "../../../FeedContainer/FeedImage/Imagemodal";
import iconHelper from '../../../../helpers/iconHelper';
import '../TabPanel.css';

import $ from "jquery";
import "./UserGallery.css";

function iconStyles() {
  return {
    successIcon: {
      color: 'green',
    },
    errorIcon: {
      color: 'red',
    },
  }
}


const useStyles = makeStyles(theme => ({
  root: {
   
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    backgroundColor: theme.palette.background.paper,
  },
  gridList: {
    width: (screen.width - 120),
    height: 1000,
  },
  
  icon: {
    color: 'rgba(255, 255, 259, 0.54)',
  },
}));

const handleScroll = (props) =>{
  if ($(window).scrollTop() + $(window).height()  ==  $(document).height()) {
      if(props.totalAlbumPage > props.albumPagination){
              
      }
    }
}

export default function Uploadgridlist(props) {

  window.addEventListener('scroll', handleScroll(props), true);
  const iconclasses = makeStyles(iconStyles)();
  const classes = useStyles();
  const open = true;
/*   const {uploadList,totalUpload,albumPagination,uploadCarousal} = props.galleryDetails;
 
  const openCarousal = (position) => {
   props.changeCarousal(position);
  }
 */
/* 
  const changeIndex = (e) => {
    $('#slide1').parent().attr('aria-hidden','true');
    $('#slide7').parent().attr('aria-hidden',false);
  }

  $( ".checkApp" ).click(function() {
    console.log('checkApp');
    $("#appModal").modal('show');
  });
 */
  const openDedicateLightBox = (index) => {
    props.toggleLightbox(index)
  }
  let uploadList = props.media_details;
  
    return (

        

            <ul>
            {uploadList.map((tile,index) => {  
                return(
                    <li key={index}>
                        <a className="portfolio_box" href={void(0)}  onClick={()=>openDedicateLightBox(index)} > 
                            {(tile.media_type == 'IMAGE') ? 
                              <img 
                              src={(tile.media_type == 'IMAGE') ? tile.media_link : tile.thumbnail} alt={tile.title} 
                              onError = {(e) => {
                                  e.target.src = iconHelper['BREAKIMAGE']
                                }}
                              />
                              :
                              <video controls className="carousal-video" controlsList="nodownload">
                                <source src={tile.media_link} type="video/mp4" />
                                Your browser does not support the video tag.
                              </video>
                            }
                            
                        </a>
                    </li>
                )
            })
            }
            </ul>
    
    );
}
